import React from "react";
import { Grid } from "@mui/material";
import * as SC from "./DataGrid.style";
import { ReactComponent as AscIcon } from "../images/sort_asc.svg";
import { ReactComponent as DescIcon } from "../images/sort_desc.svg";

export const DataGridHeader = ({
  columns,
  sorter,
  handleSort,
  visibility = [],
}) => {
  const visibleSize = {
    xs: 12,
    sm: 12,
    md: 12,
  };

  const getMdByField = (field) =>
    columns.find((item) => item.field === field)?.md ?? 0;

  if (visibility.length > 0) {
    visibleSize.md = visibility.reduce(
      (acc, next) => acc + getMdByField(next),
      0
    );
  }

  return (
    <SC.Header container columns={visibleSize}>
      {columns.map(
        ({ label, field, xs, sm, md }) =>
          (visibility.length === 0 || visibility.includes(field)) && (
            <Grid key={`${label}-${field}`} item xs={xs} sm={sm} md={md}>
              {field ? (
                <SC.HeaderItem onClick={() => handleSort(field)}>
                  {label}
                  {field === sorter.name && sorter.order === "asc" && (
                    <AscIcon />
                  )}
                  {field === sorter.name && sorter.order === "desc" && (
                    <DescIcon />
                  )}
                </SC.HeaderItem>
              ) : (
                <SC.HeaderItemWithoutSorter>{label}</SC.HeaderItemWithoutSorter>
              )}
            </Grid>
          )
      )}
    </SC.Header>
  );
};
